<template>
  <div
      class="content-block brand-block"
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="100"
  >
    <div class="block-left">
      <div class="block-number">01</div>
      <BlockHeader
          title="品牌故事"
          subtitle="百年文脉，味润宁波"
          subtitleEn="BRAND STORY"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="image-wrapper">
        <img :src="historyImage" alt="太丰发展历程" class="history-image" />
        <div class="image-overlay"></div>
        <div class="image-decoration"></div>
      </div>

      <div class="card-list">
        <div class="card-wrapper">
          <card-feature class="card-item">
            <template v-slot:title>
              一部嵌入城市脉络的百年工业史
            </template>
            <template v-slot:content>
              <div class="card-content-with-image">
                <div class="text-content">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 太丰食业的前身是 1931
                  年创立的立丰面粉厂，作为贯穿宁波近代工业进程的本土企业，它的发展始终与城市同频：1934
                  年更名 "太丰" 并于次年投产，抗战时期以本土原料保障面粉供应，1949
                  年主动支援部队军需，1954
                  年参与公私合营成为宁波最早的改制企业之一，后续历经升级、整合，2021
                  年定型为聚焦高端休闲食品的
                  "太丰食业"，在近百年里完成了从民生刚需到品质消费的转型。
                </div>
                <div class="image-container">
                  <img :src="cardImage1" alt="太丰面粉厂历史建筑" class="card-inner-image" />
                </div>
              </div>
            </template>
          </card-feature>
        </div>

        <div class="card-wrapper">
          <card-feature class="card-item">
            <template v-slot:title> 根植城市的民生与产业担当 </template>
            <template v-slot:content>
              <div class="card-content-with-image">
                <div class="text-content">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 从诞生起，太丰就以
                  "服务本土"
                  为核心底色：战时解民食之急、解放初纾军需之困，计划经济至改革开放初期则稳定区域粮食供给，如今又以高品质休闲食品适配现代健康需求。在产业层面，它既是宁波近代工业的
                  "探路者"，积累了早期生产与管理经验；也是体制改革的
                  "示范者"，率先完成公私合营转型；更成为行业创新的
                  "实践者"，探索的线上线下融合模式，为本土食品企业提供了可借鉴的路径。
                </div>
                <div class="image-container">
                  <img :src="cardImage2" alt="太丰产品生产线" class="card-inner-image" />
                </div>
              </div>
            </template>
          </card-feature>
        </div>

        <div class="card-wrapper">
          <card-feature class="card-item">
            <template v-slot:title> 从工业遗产到城市文化名片 </template>
            <template v-slot:content>
              <div class="card-content-with-image">
                <div class="text-content">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  太丰的价值不止于产业，更沉淀为城市文化的一部分：旧面粉厂建筑留存为宁波城市景观，转型后的艺术楼成为文旅新空间；作为省市两级老字号，其产品既入选
                  "宁波伴手礼"
                  成为城市名片，也斩获国际美食奖彰显品质实力，在传承本土味道的同时，也提升了宁波特色食品的文化影响力。
                </div>
                <div class="image-container">
                  <img :src="cardImage3" alt="太丰城市文化展示" class="card-inner-image" />
                </div>
              </div>
            </template>
          </card-feature>
        </div>
      </div>

      <div class="block-footer">
        <router-link :to="{ name: 'Brand' }" class="block-btn">
          <span>品牌故事</span>
          <i class="fas fa-book-open"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import BlockHeader from "../common/BlockHeader.vue";
import CardFeature from "../common/CardFeature.vue";

export default {
  components: { CardFeature, BlockHeader },
  name: "BrandBlock",
  data() {
    return {
      historyImage: require("@/assets/png/time.jpg"),
      cardImage1: require("@/assets/carousel/brand1.png"),
      cardImage2: require("@/assets/carousel/brand2.png"),
      cardImage3: require("@/assets/carousel/brand3.png")
    };
  },
  mounted() {
    this.initCircleAnimations();
  },
  methods: {
    initCircleAnimations() {
      const circles = document.querySelectorAll(
          ".stat-circle circle:nth-child(2)"
      );
      circles.forEach((circle) => {
        const length = circle.getTotalLength();
        circle.style.strokeDasharray = length;
        circle.style.strokeDashoffset = length;

        setTimeout(() => {
          circle.style.transition = "stroke-dashoffset 1.5s ease-in-out";
          circle.style.strokeDashoffset = 0;
        }, 500);
      });
    }
  }
};
</script>
<style scoped>
.brand-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.brand-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.brand-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.brand-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.brand-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.brand-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.brand-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.brand-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.brand-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.image-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 25px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.image-wrapper:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.1);
  border-color: rgba(154, 27, 30, 0.2);
}

.history-image {
  width: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s;
}

.image-wrapper:hover .history-image {
  transform: scale(1.03);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      to bottom,
      rgba(154, 27, 30, 0.03) 0%,
      rgba(154, 27, 30, 0.1) 100%
  );
  pointer-events: none;
}

.image-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(
      to right,
      transparent,
      #9a1b1e 30%,
      #b22222 70%,
      transparent
  );
  opacity: 0.6;
}

.block-right .card-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-top: 25px;
  align-items: stretch;
}

.card-wrapper {
  display: flex;
  height: 100%;
}

.card-content-with-image {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  height: 100%;
  min-height: 540px;
}

.text-content {
  flex: 1;
  line-height: 1.7;
  color: #444;
  text-align: justify;
  padding: 15px;
  overflow-y: auto;
  position: relative;
  height: calc(100% - 190px);
  max-height: calc(100% - 190px);
  min-height: 200px;
  margin-bottom: 10px;
}

.image-container {
  position: relative;
  width: calc(100% - 20px);
  margin: 0 10px 10px;
  height: 160px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  background: white;
  z-index: 10;
  flex-shrink: 0;
}

.card-inner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.image-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.15);
  border-color: rgba(154, 27, 30, 0.2);
}

.image-container:hover .card-inner-image {
  transform: scale(1.05);
}

.image-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
      to top,
      rgba(154, 27, 30, 0.9),
      rgba(154, 27, 30, 0.7)
  );
  color: white;
  padding: 8px 12px;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.3s ease;
}

.card-wrapper :deep(.feature-card) {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

.card-wrapper :deep(.feature-header) {
  flex-shrink: 0 !important;
  margin-bottom: 0 !important;
}

.card-wrapper :deep(.feature-content) {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  padding: 0 !important;
}

.text-content::-webkit-scrollbar {
  width: 4px;
}

.text-content::-webkit-scrollbar-track {
  background: rgba(154, 27, 30, 0.05);
  border-radius: 2px;
}

.text-content::-webkit-scrollbar-thumb {
  background: rgba(154, 27, 30, 0.2);
  border-radius: 2px;
}

.text-content::-webkit-scrollbar-thumb:hover {
  background: rgba(154, 27, 30, 0.3);
}

.brand-block .block-footer {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.brand-block .block-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.brand-block .block-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
  );
  transition: left 0.5s;
}

.brand-block .block-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 12px 30px rgba(154, 27, 30, 0.3);
  color: white;
  text-decoration: none;
  background: linear-gradient(135deg, #b22222, #d32f2f);
}

.brand-block .block-btn:hover::before {
  left: 100%;
}

.brand-block .block-btn i {
  transition: transform 0.3s;
}

.brand-block .block-btn:hover i {
  transform: translateX(5px);
}


@media (max-width: 1200px) {
  .brand-block .block-left {
    flex: 0 0 250px;
  }

  .block-right .card-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .card-content-with-image {
    min-height: 600px;
  }

  .text-content {
    height: calc(100% - 180px);
    max-height: calc(100% - 180px);
  }

  .image-container {
    height: 150px;
  }
}

@media (max-width: 992px) {
  .brand-block {
    flex-direction: column;
  }

  .brand-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .brand-block .block-right {
    padding: 30px 25px;
  }

  .block-right .card-list {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .card-content-with-image {
    min-height: 550px;
  }

  .text-content {
    height: calc(100% - 200px);
    max-height: calc(100% - 200px);
  }

  .image-container {
    height: 180px;
  }
}

@media (max-width: 768px) {
  .brand-block .block-left {
    padding: 25px 20px;
  }

  .brand-block .block-right {
    padding: 25px 20px;
  }

  .block-right .card-list {
    gap: 20px;
  }

  .card-content-with-image {
    min-height: 520px;
  }

  .text-content {
    height: calc(100% - 180px);
    max-height: calc(100% - 180px);
  }

  .image-container {
    height: 160px;
  }
}

@media (max-width: 480px) {
  .card-content-with-image {
    min-height: 480px;
  }

  .text-content {
    height: calc(100% - 160px);
    max-height: calc(100% - 160px);
  }

  .image-container {
    height: 140px;
  }
}

.brand-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
      circle,
      rgba(154, 27, 30, 0.03) 0%,
      transparent 70%
  );
  z-index: 0;
}

.brand-block > * {
  position: relative;
  z-index: 1;
}
</style>